export default function ThankYou() {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100dvh",
        backgroundColor: "#f3f4f6",
        padding: "0 24px",
      }}
    >
      <div
        style={{
          backgroundColor: "white",
          padding: "32px",
          borderRadius: "16px",
          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
          textAlign: "center",
          maxWidth: "400px",
        }}
      >
        <div
          style={{ color: "#10b981", fontSize: "64px", marginBottom: "16px" }}
        >
          &#10003;
        </div>
        <h1 style={{ fontSize: "24px", fontWeight: "bold", marginTop: "16px" }}>
          Top-up Successful
        </h1>
        <p style={{ color: "#6b7280", marginTop: "8px" }}>
          Your wallet has been successfully topped up.
        </p>
        <p style={{ color: "#6b7280", marginTop: "16px", fontWeight: "bold" }}>
          You may now close this tab.
        </p>
      </div>
    </div>
  );
}
